/**
 * S3 — kategori etiketi İKİ sözlükte geliyor:
 *   kayıp ailesi (990059-990063, 990065) → '(grup yok)'
 *   stok  ailesi (990044, 990046-990050, 990064) → '(kategorisiz)'
 * Ekranda TEK kova gösterilir: '(kategorisiz)'.
 */
export const KATEGORISIZ = '(kategorisiz)';
const KAYIP_KATEGORISIZ = '(grup yok)';

export function kategoriNormalize(ad: string | null | undefined): string {
  if (!ad || ad === KAYIP_KATEGORISIZ || ad === KATEGORISIZ) return KATEGORISIZ;
  return ad;
}

/** Ekrandaki kategori adını kayıp ds'lerinin @KATEGORI sözlüğüne çevirir. */
export function kategoriKayipSozlugu(ad: string): string {
  return ad === KATEGORISIZ ? KAYIP_KATEGORISIZ : ad;
}

/**
 * Kategorisi satirda gelen ds'leri ISTEMCIDE suzer: bu ds'ler @KATEGORI bildirmez (ana rapor anahtari degismesin,
 * yeniden sorgu acilmasin). `secili` null ise satirlar aynen doner.
 */
export function kategoriSuz<T extends { kategori: string }>(satirlar: T[], secili: string | null | undefined): T[] {
  if (!secili) return satirlar;
  return satirlar.filter((s) => kategoriNormalize(s.kategori) === secili);
}
